import {BaseModel} from "./Base";
import {ContactModel} from "./Contact";

import { IAddress, AddressModel } from "./Address"


    export interface ICompany {
      name: string,
      email: string,
      phone: string,
      legalform: string,
      coc: string,
      startdate: string,
      sbi_code: string,
      sbi_description: string,
      vatid: string,
      type: string,
      key: string,
      addresses: Array<IAddress>,
      contact: Array<any>,
    }

    export class CompanyModel extends BaseModel  {
      name: string = "";
      email: string = "";
      phone: string = "";
      legalform: string = "";
      coc: string = "";
      startdate: string = "";
      sbi_code: string = "";
      sbi_description: string = "";
      vatid: string = "";
      type: string = "0";
      key: string = "";
      _addresses: AddressModel[] = new Array();
      _contact: ContactModel[] = []
       
        constructor(data = null) {
            super();
            if(data) {
                this.syncData(data);
            }
        }      
      
     public createContact =(data = null) => {
          let contact = new ContactModel(data);
          this._contact.push( contact );
      }
      
      public createAddress =(data = null) => {
          let address = new AddressModel(data);
          this.setAddresses(address);
      }
      
      public syncData(data) {
            if(data) {
                Object.keys(data).map((item) => {
                        if(item != "addresses") {
                            this[item] = data[item];
                        } else if(item == "addresses") {
                            for(let i in data[item]) {
                                this.createAddress(data[item][i] );
                            }                        
                        }
                    //}
                });
                if(!this._addresses || this._addresses.length == 0) {
                    this.createAddress();
                }
                if(!this._contact || this._contact.length == 0) {
                    this.createContact();
                }
                
            }
      }
      
      public set addresses(val) {
          this._addresses = val;
      }
      public set contact(val:[]) {
        this._contact = val;
      }
      
      public setAddresses(val) {
        this._addresses.push(val);
          return this._addresses;
      }
      
      public get addresses() {
          return this._addresses;
      }
      public get contact() : any{
          return this._contact;
      }
      
      
      
      
    }